import { useCallback, useEffect, useRef } from 'react';

/** Disable scrolling when the user use keyboard arrows */
export const useDisableScrollOnKeyboardEvent = (disabled?: boolean) => {
  const binded = useRef(false);

  const handleScroll = (e: KeyboardEvent) => {
    const keys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];

    if (keys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const bind = useCallback(() => {
    binded.current = true;
    document.body.addEventListener('keydown', handleScroll);
  }, []);

  const unbind = useCallback(() => {
    binded.current = false;
    document.body.removeEventListener('keydown', handleScroll);
  }, []);

  useEffect(() => {
    if (disabled) {
      if (binded.current) unbind();
    } else if (!binded.current) bind();
    return () => unbind();
  }, [bind, disabled, unbind]);
};

export default useDisableScrollOnKeyboardEvent;
